import { Expose, Transform, Type } from 'class-transformer';

import {
	dateTransformer,
	temporalPlainDateTransformer,
} from 'src/lib/utilities/api/class-transformer-types';
import { ProgramFileModel } from '../../organizations/management/files-service/program-file.model';
import {
	WorkQueueTrackerResponseModel,
	WorkQueueTrackerResponseModel_ClassTransform_Type,
} from '../../work-queue/work-queue-entity.model';
import {
	ClassroomSessionModel,
	ClassroomSessionModel_ClassTransform_Type,
} from './classroom-session.model';
import {
	ClassroomModel,
	ClassroomModel_ClassTransform_Type,
} from './classroom.model';

export class ClassroomStudentAssignmentModel {
	association_id: number;
	student_uid: number;
	classroom_id: number;
	start_timestamp: number;
	end_timestamp: number;
	is_active: boolean;
	is_primary: boolean;
}

export function ClassroomStudentAssignmentModel_ClassTransform_Type() {
	return ClassroomStudentAssignmentModel;
}

export class ClassroomStudentResponseErrorModel {
	error: string;
	name: string;
	uid: number;
}

export function ClassroomStudentResponseErrorModel_ClassTransform_Type() {
	return ClassroomStudentResponseErrorModel;
}

export class ClassroomStudentAssignmentResponseModel {
	@Type(ClassroomStudentAssignmentModel_ClassTransform_Type)
	assignments: ClassroomStudentAssignmentModel[];
	@Type(ClassroomStudentResponseErrorModel_ClassTransform_Type)
	errors: ClassroomStudentResponseErrorModel[];
}

export class ClassroomStudentTrackerClassroomModel {
	id: number;
	name: string;
	activated: boolean;
}

export function ClassroomStudentTrackerClassroomModel_ClassTransform_Type() {
	return ClassroomStudentTrackerClassroomModel;
}

export class ClassroomStudentTrackerCourseModel {
	id: number;
	course_id: number;
	course_number: string;
	title: string;
	teacher_name: string | null;
	section_name: string | null;
	registration_type: string | null;
	@Transform(dateTransformer)
	end_date: Date;
	term: number;
	term_type_code: string;
}

export function ClassroomStudentTrackerClassModel_ClassTransform_Type() {
	return ClassroomStudentTrackerCourseModel;
}

export class ClassroomStudentTrackerStudentModel {
	uid: number;
	@Type(WorkQueueTrackerResponseModel_ClassTransform_Type)
	queues: WorkQueueTrackerResponseModel[];
	profile_first_name: string;
	profile_preferred_name: string;
	profile_last_name: string;
	program_id: number;
	program_type: string;
	program_title: string;
	program_parent_title: string;
	program_state: string;
	grade: string;
	@Transform(temporalPlainDateTransformer)
	birthdate: Temporal.PlainDate;
	@Transform(dateTransformer)
	activation_date: Date;
	@Expose({ name: 'classroom_start_timestamp' })
	@Transform(dateTransformer)
	classroom_start_date: Date;
	is_enrolled: boolean;
	assigned_learning_coach_first: string;
	assigned_learning_coach_last: string;
	assigned_learning_coach_uid: number;
	assigned_family_advocate_first: string;
	assigned_family_advocate_last: string;
	assigned_family_advocate_uid: number;
	@Type(ClassroomStudentTrackerClassModel_ClassTransform_Type)
	classes: ClassroomStudentTrackerCourseModel[];
}
export function ClassroomStudentTrackerStudentModel_ClassTransform_Type() {
	return ClassroomStudentTrackerStudentModel;
}

export class ClassroomStudentTrackerSessionCourseModel {
	course_id: number;
	course_number: string;
	course_name: string;
	term_type_code: string;
	term: number;
}

export function ClassroomStudentTrackerSessionCourseModel_ClassTransform_Type() {
	return ClassroomStudentTrackerSessionCourseModel;
}

export class ClassroomStudentTrackerSessionModel {
	id: number;
	name: string;
	activated: boolean;
	@Type(ClassroomStudentTrackerSessionCourseModel_ClassTransform_Type)
	courses: ClassroomStudentTrackerSessionCourseModel[];
	program_ids: number[];
}

export class ClassroomStudentsTrackerModel {
	@Type(ClassroomStudentTrackerClassroomModel_ClassTransform_Type)
	classroom: ClassroomStudentTrackerClassroomModel;
	@Type(ClassroomSessionModel_ClassTransform_Type)
	session: ClassroomStudentTrackerSessionModel;
	@Type(ClassroomStudentTrackerStudentModel_ClassTransform_Type)
	students: ClassroomStudentTrackerStudentModel[];
}

export class ClassroomStudentProgramModel {
	calendar: unknown[];
	@Type(() => ProgramFileModel)
	community_file: ProgramFileModel | null;
}

export function ClassroomStudentProgramModel_ClassTransform_Type() {
	return ClassroomStudentProgramModel;
}

export class ClassroomStudentModel {
	@Type(ClassroomStudentAssignmentModel_ClassTransform_Type)
	classroom_association: ClassroomStudentAssignmentModel;
	@Type(ClassroomModel_ClassTransform_Type)
	classroom: ClassroomModel;
	@Type(ClassroomSessionModel_ClassTransform_Type)
	session: ClassroomSessionModel;
	@Type(ClassroomStudentProgramModel_ClassTransform_Type)
	program: ClassroomStudentProgramModel;
}

export class ClassroomReassignResultModel {
	reassigned_student_ids: number[];
	@Type(ClassroomStudentResponseErrorModel_ClassTransform_Type)
	errors: ClassroomStudentResponseErrorModel[];
}

export interface ClassroomReassignStudentsArgument {
	student_ids: number[];
	new_classroom_id: number;
	withdraw_courses: boolean;
}
